import { render } from "./TextFormula.vue?vue&type=template&id=710b6ce4"
import script from "./TextFormula.vue?vue&type=script&lang=js"
export * from "./TextFormula.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/blackhall/V3/v2026.27.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__